export default __webpack_public_path__ + "static/media/profile_Boda.75142605.jpg";